import { Component, Injectable, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GradeModel } from 'src/app/Models/GradeModel';
import { NumberValidator } from 'src/app/country-picker/number-validator';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SourceIdEnum } from 'src/app/Models/sourceIdEnumModel';
import { RegistrationComponent } from '../registration/registration.component';
import { LeadFormTitle } from 'src/app/enum/LeadFormTitle';
import { CourceService } from 'src/app/services/cource.service';

@Component({
  selector: 'app-connect-to-counsellor',
  templateUrl: './connect-to-counsellor.component.html',
  styleUrls: ['./connect-to-counsellor.component.css'],
})
@Injectable({
  providedIn: 'root',
})
export class ConnectToCounsellorComponent implements OnInit {
  form!: FormGroup;
  getGrade: Array<GradeModel> = [];
  isUserExists!: boolean;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private courseService: CourceService
  ) {
  }

  ngOnInit() {
    this.removeariahidden();
    // Simulate fetching grades (replace with actual service if needed)
  }
  closeModal() {
    this.modalService.dismissAll();
  }
  removeariahidden() {
    const rootElement = document.querySelector('app-root');
    if (rootElement?.hasAttribute('aria-hidden')) {
      rootElement.removeAttribute('aria-hidden');
    }
  }
}
